import initWelcomeTour from './init-welcome-tour';

export default {
  initWelcomeTour,
};
